import {IconButton, styled} from "@mui/material";
import {color} from "../../../theme/includes/color";


export const StyledIconButton = styled(IconButton)({
  svg: {
    border: '2px solid transparent',
  },
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    svg: {
      borderRadius: '16px',
      borderColor: color('grey-400'),
    }
  }
})